module.exports = __webpack_public_path__ + "img/derrick.41870c02.png";